module.exports = __webpack_public_path__ + "9ba0a5eb8ef6e9d908f4d388f4e852b7.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/BA.svg
// module id = SF/t
// module chunks = 0